import axios from 'axios';
import * as types from '../mutation-types';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    // properties to store tenants data
    endpoint: endpoints.tenant.endpoint, // "tenant",
    tenants: [],
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the tenants data
    tenants: state => state.tenants,
    tenantByID: state => id => {
      for (const tenant of state.tenants) {
        if (tenant.eid === id) return tenant;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.TENANTS_LOAD](state, tenants) {
      state.tenants = JSON.parse(JSON.stringify(tenants));
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetchByIDs: (context, paginationData) => {
      const ids = paginationData.ids;
      if (typeof ids === 'undefined') {
        console.error("tenant/fetchByIDs ids is undefined");
        return
      }
      const api = context.rootGetters['global/apiUrl'] + '/' + context.state.endpoint + '/' + ids.join(',') + ',';

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          params: {
            fields: paginationData.fields
          },
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.objects == null) r.data.objects = {}
              context.commit(types.TENANTS_LOAD, r.data.objects);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "s";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
              context.commit(types.TENANTS_LOAD, r.data.rows);
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    create: (context, data) => {
      context.commit(`cache/${types.CACHE_INVALIDATE}`, 'tenants', {
        root: true
      });

      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    read: (context, id) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    update: (context, data) => {
      context.commit(`cache/${types.CACHE_INVALIDATE}`, 'tenants', {
        root: true
      });

      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + data.eid;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'PUT'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    delete: (context, ids) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/deleteById";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: {
            ids
          },
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    bulkAction: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/bulkAction";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
  }
};
